<template>
    <div class="grid xs-grid-cols-2 sm-grid-cols-4 fixed fixed-max-sm gap-3">
        <h2 class="wrap" v-if="title">
            <b class="f3 text-capitalize text-bold">{{title}}</b>
        </h2>
        <div class="inline corner bg-main" v-for="item in data">
            <div>{{item.text}}</div>
            <div><b class="f3">{{$filters.formatNumber(item.count)}}</b></div>
            <div class="singleline"><a :href="glb.appUrl+item.link" class="link" v-if="showLinks">See {{item.text}}</a>
            </div>
        </div>
    </div>
</template>

<script src="./schools-cardsection.js"></script>

